"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Card = void 0;
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _reactI18next = require("react-i18next");
var _ui = require("../../../../ui");
var _hooks = require("../../../../../hooks");
var _transactionInfo = require("../../withdraw/transaction-info");
var _empty = _interopRequireDefault(require("./empty.png"));
var _excluded = ["tooltipServiceName", "balanceName", "children"];
var _templateObject, _templateObject2;
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
var NoData = (0, _styledComponents.default)(_ui.NoData)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  padding: 0;\n"])));
var StyledTotalAmount = (0, _styledComponents.default)(_transactionInfo.TransactionInfoTotalAmount)(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  margin: 20px 0;\n"])));
var Card = function Card(_ref) {
  var tooltipServiceName = _ref.tooltipServiceName,
    balanceName = _ref.balanceName,
    children = _ref.children,
    props = _objectWithoutProperties(_ref, _excluded);
  var _useTranslation = (0, _reactI18next.useTranslation)(['libTransfers', 'libCommon']),
    t = _useTranslation.t;
  var _useExchangeContext = (0, _hooks.useExchangeContext)(),
    amount = _useExchangeContext.amount,
    toAmount = _useExchangeContext.toAmount,
    ticker = _useExchangeContext.ticker,
    toTicker = _useExchangeContext.toTicker,
    balanceAfterTransaction = _useExchangeContext.balanceAfterTransaction,
    total = _useExchangeContext.total,
    fee = _useExchangeContext.fee,
    exchangeInfo = _useExchangeContext.exchangeInfo,
    price = _useExchangeContext.price,
    isEnoughBalance = _useExchangeContext.isEnoughBalance,
    maxLiquidity = _useExchangeContext.maxLiquidity;
  return /*#__PURE__*/_react.default.createElement(_ui.Card, null, /*#__PURE__*/_react.default.createElement(_ui.CardHeader, null, /*#__PURE__*/_react.default.createElement(_ui.CardTitle, null, t('transactionDetails'))), /*#__PURE__*/_react.default.createElement(_ui.CardBody, {
    className: "pt-0"
  }, exchangeInfo.data && isEnoughBalance ? /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_transactionInfo.TransactionInfoItem, {
    title: t('exchange') + ':'
  }, /*#__PURE__*/_react.default.createElement(_ui.H6, {
    className: "mb-0"
  }, ticker, " to ", toTicker)), /*#__PURE__*/_react.default.createElement(_transactionInfo.TransactionInfoAmountItem, {
    title: t('amountToSend') + ':',
    ticker: toTicker
    // fiatTicker={fiatTicker}
    ,
    amount: toAmount
    // fiatTickerAmount={fiatTickerToAmount}
  }), /*#__PURE__*/_react.default.createElement(_transactionInfo.TransactionInfoAmountItem, {
    title: t('amountToWithdraw') + ':',
    ticker: ticker
    // fiatTicker={fiatTicker}
    ,
    amount: amount
    // fiatTickerAmount={fiatTickerAmount}
  }), maxLiquidity && /*#__PURE__*/_react.default.createElement(_transactionInfo.TransactionInfoAmountItem, {
    title: t('maxLiquidity') + ':',
    ticker: ticker,
    amount: maxLiquidity
  }), /*#__PURE__*/_react.default.createElement(_transactionInfo.TransactionInfoAmountItem, {
    title: t('exchangeRate') + ':',
    tooltip: t('rateUpdates') + '.',
    ticker: price === null || price === void 0 ? void 0 : price.pair[0],
    fiatTicker: price === null || price === void 0 ? void 0 : price.pair[1],
    amount: '1',
    fiatTickerAmount: price === null || price === void 0 ? void 0 : price.value
  }), /*#__PURE__*/_react.default.createElement(_transactionInfo.TransactionInfoAmountItem, {
    title: t('fee') + ':',
    tooltip: t('includingFees') + '.',
    ticker: toTicker
    // fiatTicker={fiatTicker}
    ,
    amount: fee
    // fiatTickerAmount={fiatTickerFee}
  }), /*#__PURE__*/_react.default.createElement(StyledTotalAmount, {
    ticker: toTicker,
    amount: total
    // convertedTicker={fiatTicker}
    // convertedAmount={fiatTickerTotal}
  }), /*#__PURE__*/_react.default.createElement(_transactionInfo.TransactionInfoAmountItem, {
    title: "".concat(balanceName, " ").concat(t('libCommon:balance').toLowerCase(), " ").concat(t('after'), ":"),
    ticker: ticker
    // fiatTicker={fiatTicker}
    ,
    amount: balanceAfterTransaction
    // fiatTickerAmount={fiatBalanceAfterTransaction}
  }), children) : /*#__PURE__*/_react.default.createElement(NoData, {
    imageComponent: function imageComponent() {
      return /*#__PURE__*/_react.default.createElement("img", {
        src: _empty.default,
        alt: "Transaction details"
      });
    },
    subtitle: t('txDetailsWillBeHere')
  })));
};
exports.Card = Card;